import TransferAccountsTabStore from './TransferAccountsTabStore';

const useSelectedTransferAccount = () =>
  TransferAccountsTabStore(state => state.selectedTransferAccount);

const useSetSelectedTransferAccount = () =>
  TransferAccountsTabStore(state => state.setSelectedTransferAccount);

export { useSelectedTransferAccount, useSetSelectedTransferAccount };
